import React from "react";
import IssuesListData from "./table/IssuesListData";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function IssuesList() {
  const Navigate = useNavigate();
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addIssues = Array.isArray(Permissions) ? Permissions?.find((o) => o.codename === "add_issues"):[]

  return (
    <div>
      <div>
        <h2 className="font-Montserrat text-xl font-bold text-black">Issues</h2>
        <div className="border-b-2 border-blue-200 w-10"></div>
      </div>

      <div class="flex flex-wrap ">
        <div class="w-full md:overflow-x-auto sm:overflow-x-auto ">
          <div
            className=" overflow-auto float-right"
            // "w-[calc(100vw_-_12rem)]"
          >
          {!addIssues ===undefined ||  addIssues?.codename ===
              "add_issues" ? (
          <button
              type="button"
              onClick={() =>
                Navigate(
                  "/dashboard/production/issues/report-issue"
                )
              }
              className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-48 "
            >
              Report Issue
            </button>
            ) : null
            }
          </div>
          <div class=" flex border-b float-right mr-8 border-b-violet-800 ">
            <input
              class="w-full bg-transparent rounded-lg p-2"
              type="text"
              placeholder="Search"
            />
            <button class=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                  fill="#1F78B4"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          {/* <Itemsdata /> */}
          <IssuesListData />
        </div>
      </div>
    </div>
  );
}
